module.exports = __webpack_public_path__ + "img/border-patrol.76834142.jpg";